import { useRecoilValue } from 'recoil'
import { Box, Title } from './styles'
import ClaimFormStatusTag from '@/components/feature/HealthClaimDetailPage/ClaimFormStatusTag/ClaimFormStatusTag'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import { HealthClaimModeEnum } from '@/constant/E_CLAIM'

const ClaimDetailTitle = () => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const isCreateMode = healthClaim.mode === HealthClaimModeEnum.CREATE

  const textTitle = isCreateMode
    ? 'สร้างเคสเคลมประกันสุขภาพและอุบัติเหตุ'
    : 'รายละเอียดการยื่นเคลมประกันสุขภาพและอุบัติเหตุ'

  return (
    <Box>
      <Title>
        {textTitle}
        {!isCreateMode && healthClaim.data?.statusCode && (
          <ClaimFormStatusTag status={healthClaim.data.statusCode} />
        )}
      </Title>
    </Box>
  )
}

export default ClaimDetailTitle
